import React, { Component } from 'react';
import { ListGroup, Modal, Button, Form } from 'react-bootstrap';
import search from '../../assets/img/icons/search.svg';
import Location from './location';
import axios from 'axios';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Passion extends Component {
    constructor(props) {
        super(props);
        this.onSubmitinterest = this.onSubmitinterest.bind(this);
        this.state = {
            interests_data: [],
            selectedPassions: [],
            searchQuery: '',
            locationmodal: false,
            api_url: localStorage.getItem('api_url'),
        };
    }

    componentDidMount() {
		axios.get(this.state.api_url+`admindatas`)
        .then(res => {
            const interests_data = res.data.result.interests;
            this.setState({ interests_data });	
        });
	}

    handlePassion = (passion) => {
        const isSelected = this.state.selectedPassions.includes(passion);
        if (isSelected) {
            this.setState(prevState => ({
                selectedPassions: prevState.selectedPassions.filter(item => item !== passion)
            }));
        } else {
            this.setState(prevState => ({
                selectedPassions: [...prevState.selectedPassions, passion]
            }));
        }
    };

    handleSearchChange = (event) => {
        this.setState({ searchQuery: event.target.value });
    }

    onSubmitinterest = e => {
        e.preventDefault();
        if(this.state.selectedPassions.length === 0 || this.state.selectedPassions === '') {
            this.setState({ nopassion: 'Please select the any passion' });
            setTimeout(() => {
                this.setState({
                    nopassion: ''
                });
            }, 2000);
        } else {
            localStorage.setItem('seleted_passion', this.state.selectedPassions);
            this.props.handleClose();
            this.handleLocationOpenModal();
        }
        
    }

    handleLocationOpenModal = () => {
        this.setState({ locationmodal: true });
    }

    handleLocationCloseModal = () => {
        this.setState({ locationmodal: false });
    }

    render() {
        const passions = this.state.interests_data.map(item => item.name);
        const filteredPassions = passions.filter(passion =>
            passion.toLowerCase().includes(this.state.searchQuery.toLowerCase())
        );

        return (
            <div className="">
                <Modal className="modal_div" show={this.props.showModal} centered>
                    <Form className='' onSubmit={this.onSubmitinterest}>
                        <Modal.Header>
                            <Modal.Title><Trans i18nKey="Passions & Pursuits">Passions & Pursuits</Trans></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="passion_modal">
                            <div>
                                <div className='search'>
                                    <img src={search} alt="img" />
                                    <Form.Control
                                        placeholder="search passions & pursuits"
                                        value={this.state.searchQuery}
                                        onChange={this.handleSearchChange} />
                                </div>
                                <div className="passion_modal_height">
                                    <ListGroup>
                                        {filteredPassions.map(passion => (
                                            <ListGroup.Item
                                                key={passion}
                                                active={this.state.selectedPassions.includes(passion)}
                                                onClick={() => this.handlePassion(passion)}
                                            >
                                                {passion}
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                </div>
                            </div>
                        </Modal.Body>
                        <div className="errorMsg" style={{ paddingLeft: "25px" }}>{this.state.nopassion}</div>
                        <Modal.Footer className="forgot_button_plr">
                            <Button type="submit" className='button_primary'><Trans i18nKey="Save">Save</Trans></Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
                <Location
                    showModal={this.state.locationmodal}
                    handleClose={this.handleLocationCloseModal}
                />
            </div>
        );
    }
}

export default Passion;
